export default __webpack_public_path__ + "static/media/payments_and_invoices_page.24476e24.png";